module.exports = __webpack_public_path__ + "img/PS20.7af69a80.png";